import { Flex } from '@chakra-ui/react'
import { FeaturesDualList } from '@features/staffMember/components/features/FeaturesDualList'
import { createFileRoute, useParams } from '@tanstack/react-router'
import { SentryErrorComponent } from '@components/Fallback'

const OrgFeaturesRoute = () => {
  const { orgId } = useParams({ from: '/_auth/staff/o/$orgId/features' })

  return (
    <Flex justifyContent={'center'} w="full" h="full">
      <FeaturesDualList orgId={orgId} />
    </Flex>
  )
}

export const Route = createFileRoute('/_auth/staff/o/$orgId/features')({
  component: OrgFeaturesRoute,
  beforeLoad: () => ({ getTitle: () => 'Org Features' }),
  errorComponent: SentryErrorComponent,
  loader: () => ({
    crumb: 'Features',
  }),
})
